import { useState, useCallback } from "react";

export interface PendingOrder {
  id: string;
  data: any;
}

export const usePendingOrders = () => {
  const [pendingOrders, setPendingOrders] = useState<PendingOrder[]>([]);
  const [processedOrderIds, setProcessedOrderIds] = useState<Set<string>>(new Set());

  const addPendingOrder = useCallback((order: PendingOrder) => {
    setPendingOrders((prev) => {
      // Check if order already exists in queue
      if (prev.some((o) => o.id === order.id)) {
        return prev;
      }
      return [...prev, order];
    });
  }, []);

  const removePendingOrder = useCallback((orderId: string) => {
    setPendingOrders((prev) => prev.filter((o) => o.id !== orderId));
    setProcessedOrderIds((prev) => new Set(prev).add(orderId));
  }, []);

  const clearPendingOrders = useCallback(() => {
    setPendingOrders([]);
  }, []);

  const isOrderProcessed = useCallback((orderId: string) => {
    return processedOrderIds.has(orderId);
  }, [processedOrderIds]);

  const currentPendingOrder = pendingOrders[0] || null;
  const hasPendingOrders = pendingOrders.length > 0;

  return {
    pendingOrders,
    currentPendingOrder,
    hasPendingOrders,
    addPendingOrder,
    removePendingOrder,
    clearPendingOrders,
    isOrderProcessed,
  };
};
